import { useMixpanel } from 'react-mixpanel-browser'
import _ from 'lodash'

const mixPanelToken = _.get(window, ['_env_', 'MX_PANEL_TOKEN'], null)

function useMixPanelTracking() {
  const mixPanel = useMixpanel()
  return {
    track: (eventName, params) => {
      // if token is not configured meaning that,
      // this instance is not suppose to send the events
      if (_.isEmpty(mixPanelToken)) {
        return
      }

      try {
        mixPanel.track(eventName, params)
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    },
    identify: emailId => {
      if (_.isEmpty(mixPanelToken)) {
        return
      }

      try {
        mixPanel.identify(emailId)
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    },
    set_people: params => {
      // if token is not configured meaning that,
      // this instance is not suppose to send the events
      if (_.isEmpty(mixPanelToken) || _.isEmpty(params)) {
        return
      }

      try {
        mixPanel.people.set_once(params)
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    }
  } // end of return
}

export default useMixPanelTracking
